
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.md?watch=parent';
    export const demoIndex = {
  ids: ["funnel-demo-common","funnel-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Funnel" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Funnel/index.md?type=demo')
};